import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { SHARED_LIB_CONFIG, SharedLibConfig } from '../config/lib-config';
import { SectionDefinitionEntityType } from '../models/section-definition.model';
import { ResponsePackage } from '../models/util.model';
import { UpdateAttributeValue } from '../helpers/section-instance-edit.helper';

@Injectable({
  providedIn: 'root',
})
export class DmcService {
  private pathApi: string;

  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  constructor(
    private http: HttpClient,
    @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig,
  ) {
    this.pathApi = this.config.pathApi + 'sharedDMC/';
  }

  getInstancesForAsset(dataIn: {
    entityType: SectionDefinitionEntityType;
    assetGuid: string;
  }) {
    return this.http.post<ResponsePackage<any>>(
      `${this.pathApi}getInstancesForAsset`,
      dataIn,
      { headers: this.headers, observe: 'response' },
    );
  }

  updateAttributeValues(dataIn: {
    assetType: SectionDefinitionEntityType;
    assetGuid: string;
    attributeValues: UpdateAttributeValue[];
    staticValues?: { staticPropertyName: string; stringValue?: string | null; intValue?: number | null; boolValue?: boolean | null }[];
  }) {
    return this.http.post<ResponsePackage<any>>(
      `${this.pathApi}updateAttributeValues`,
      dataIn,
      { headers: this.headers, observe: 'response' },
    );
  }
}
